var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fixed inset-0 z-50",
      class: { "pt-smh": _vm.$root.siteMessageIsVisible },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col h-full bg-paint px-ogs-large overflow-x-hidden overflow-y-scroll scrolling-touch pb-10",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex-shrink-0 h-shh flex items-center relative z-10",
            },
            [
              _c(
                "button",
                {
                  staticClass: "block w-12 focus:outline-none text-theme",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("IconArrowLeftAlt")],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-1 py-6 relative z-0" },
            [
              _vm.heading
                ? _c("h2", { staticClass: "text-lg text-theme mb-8" }, [
                    _vm._v(_vm._s(_vm.heading)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }